import { render, staticRenderFns } from "./orderListDetails.vue?vue&type=template&id=0a985f83&scoped=true"
import script from "./orderListDetails.vue?vue&type=script&lang=js"
export * from "./orderListDetails.vue?vue&type=script&lang=js"
import style0 from "./orderListDetails.vue?vue&type=style&index=0&id=0a985f83&prod&lang=less&scoped=true"
import style1 from "./orderListDetails.vue?vue&type=style&index=1&id=0a985f83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a985f83",
  null
  
)

export default component.exports